import React, { useState } from "react";
import "./AddUserForm.css";
import { FiRefreshCw } from "react-icons/fi"

function generatePassword() {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let pwd = "";
  for (let i = 0; i < 6; i++) {
    pwd += letters.charAt(Math.floor(Math.random() * letters.length));
  }
  return pwd;
}

export default function AddUserForm({ onCancel, onSave }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    organisation: "",
    role: "Staff",
    password: generatePassword(),
  });
  const [error, setError] = useState("");

  function update(k, v) {
    setForm((p) => ({ ...p, [k]: v }));
  }

  function regenerate() {
    update("password", generatePassword());
  }

  function submit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.organisation.trim()) {
      setError("Name, email, and organisation are required.");
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      setError("Enter a valid email.");
      return;
    }
    if (!/^[A-Za-z0-9]{6}$/.test(form.password)) {
      setError("Password must be 6 alphanumeric characters.");
      return;
    }

    setError("");
    onSave(form);
  }

  return (
    <div className="form">
      <form onSubmit={submit}>
        <div className="form-row">
          <label className="form-label">Name</label>
          <input
            className="input"
            value={form.name}
            onChange={(e) => update("name", e.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label className="form-label">Email</label>
          <input
            className="input"
            type="email"
            value={form.email}
            onChange={(e) => update("email", e.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label className="form-label">Organisation</label>
          <input
            className="input"
            value={form.organisation}
            onChange={(e) => update("organisation", e.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label className="form-label">Role</label>
          <select
            className="input"
            value={form.role}
            onChange={(e) => update("role", e.target.value)}
          >
            <option value="Admin">Admin</option>
            <option value="Manager">Manager</option>
            <option value="Staff">Staff</option>
          </select>
        </div>

        <div className="form-row">
          <label className="form-label">Password</label>
          <div className="input-with-btn">
            <input
              className="input"
              value={form.password}
              onChange={(e) => update("password", e.target.value)}
              maxLength={7}
              required
            />
            <button
              type="button"
              className="btn icon-btn"
              onClick={regenerate}
              title="Regenerate Password">
            <FiRefreshCw size={18} />
    </button>
          </div>
        </div>

        {error && <p className="error">{error}</p>}

        <div className="actions">
          <button type="button" className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="btn primary">
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
